import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/taskpane/components/ui/dialog";
import { Button } from "@/taskpane/components/ui/button";
import { useLogout } from "@/hooks/useLogout";

interface RequestAccessDialogProps extends React.ComponentPropsWithoutRef<typeof Dialog> {}

const RequestAccessDialog = ({ ...props }: RequestAccessDialogProps) => {
  const logoutMutation = useLogout();

  const handleSwitchAccount = () => {
    logoutMutation.mutate();
  };

  return (
    <Dialog {...props}>
      <DialogContent
        showCloseButton={false}
        // The user has no valid path forward except "Switch Account", so block
        // every implicit dismissal (Escape key, overlay click, focus leak) at
        // the Radix level rather than relying on the parent's no-op
        // onOpenChange. Makes the non-dismissable intent explicit and robust
        // against future Radix changes.
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <img
            src="assets/aila-logo-updated.png"
            alt="Logo"
            className="w-[130px] h-auto mb-4 mx-auto"
          />
          <DialogTitle>Request Access</DialogTitle>
          <DialogDescription className="text-neutral-400">
            You don&apos;t have permission to access this document. Please contact the document
            owner to request access.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-col gap-2">
          <Button
            variant="outline"
            onClick={handleSwitchAccount}
            className="w-full"
            disabled={logoutMutation.isPending}
          >
            {logoutMutation.isPending ? "Switching Account..." : "Switch Account"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RequestAccessDialog;
